export const CURRENCIES = [
    { label: "KZT (₸)", value: "kzt" },
    { label: "USD ($)", value: "usd" },
    { label: "EUR (€)", value: "eur" },
    { label: "RUB (₽)", value: "rub" }
];